import API from '@/views/Fdc/Apis/'
// import { mapGetters } from 'vuex'
import Dayjs from 'dayjs'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1. paging 처리

/**
 * Analysis > EQP History
 * EQP History 목록 조회
 */
export default {
  name: 'EqpLotHistory',
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  watch: {
    // rowData () {
    //   if (this.rowData.length === 0) {
    //     this.noData = true
    //   } else {
    //     this.noData = false
    //   }
    // }
  },
  beforeMount () {
    this.initColumns()
  },
  methods: {
    /**
     * Grid Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', minWidth: 70, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.START_DATE'), field: 'startDt', flex: 1, type: 'dateTimeColumn', minWidth: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.END_DATE'), field: 'endDt', flex: 1, type: 'dateTimeColumn', minWidth: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_TYPE'), field: 'eventType', centered: true, flex: 1, minWidth: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', minWidth: 150, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SLOT'), field: 'slot', numeric: true, minWidth: 50, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.BATCH_ID'), field: 'batchId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.OPER_ID'), field: 'operId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROCESS'), field: 'procId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), field: 'reticleId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PPID'), field: 'ppId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.DEVICE'), field: 'device', minWidth: 100, flex: 1 }
      ]
    },
    /**
     * EQP Event History 목록 조회
     */
    async getEqpEventHistoryList () {
      let result = []

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      var count = this.$refs.fdcEqpTree.$children[1].data.length
      for (var i = 0; i < count; i++) {
        result.push(this.$refs.fdcEqpTree.$children[1].getObjFromNode(this.$refs.fdcEqpTree.$children[1].data[i], { isChecked: true, level: 5 }))
      }
      // console.log(result)
      var treeSelectedCount = 0
      result.forEach((item) => {
        if (item.length === 0) {
          treeSelectedCount++
        }
      })

      if (treeSelectedCount >= count) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.MODULE')]))
        return false
      }

      if (this.$refs.fromDate.$data.dateSelected === null || this.$refs.toDate.$data.dateSelected === null) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.PERIOD')]))
        return false
      }
      let params = {}
      let fab = []
      let eqpId = []
      let moduleId = []

      result.forEach(item => {
        item.forEach(data => {
          fab.push(data.detail.fab)
          eqpId.push(data.detail.eqpId)
          moduleId.push(data.detail.moduleId)
        })
      })

      params = {
        fab: fab + '',
        eqpId: eqpId + '',
        moduleId: moduleId + '',
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000999',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999',
        page: this.paging.currentPage,
        size: this.paging.size
      }
      // console.log(params)
      let data = await API.Monitor.getEqpsEvents(params)

      if (data.content.length > 0) {
        this.rowData = data.content
        this.originRowData = data.content
        this.paging.total = data.totalElements
        this.paging.totalPage = data.totalPages
        // TODO: paging 관련 처리 추가
        this.paging.currentPage = data.pageable.pageNumber
      } else {
        this.rowData = []
        this.originRowData = []
        this.paging.total = 0
        this.paging.totalPage = 0
        this.paging.currentPage = 0
      }
      // if (data._embedded) {
      //   this.rowData = data._embedded.retEventDataVoes
      //   this.originRowData = data._embedded.retEventDataVoes
      //   this.paging.total = data.page.totalElements
      //   this.paging.totalPage = data.page.totalPages
      //   this.paging.currentPage = data.page.number
      // } else {
      //   this.rowData = []
      //   this.originRowData = []
      //   this.paging.total = 0
      //   this.paging.totalPage = 0
      //   this.paging.currentPage = 0
      // }
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    // pagination type 시 page 변경 전 수정여부 확인
    changingPage (event) {
    },
    /**
     * Grid Change Page method
     * @param {*} page current page
     * @param {*} size page size
     */
    changedPage (page, size) {
      this.paging.currentPage = page
      this.getEqpEventHistoryList()
    },
    /**
     * Export Excel
     * 조회된 data를 Excel 파일로 다운로드 합니다.
     */
    exportCSV () {
      this.$refs.eqpHistoryGrid.gridApi.exportDataAsCsv({
        fileName: 'Eqp_History.csv'
      })
      // this.$refs.eqpHistoryGrid.exportExcel('Eqp_History')

      //   // var objArray = this.$refs.eqpHistoryGrid.itemsSource
      //   var objArray = new Array()
      //   this.$refs.eqpHistoryGrid.itemsSource.forEach(item => {
      //     let obj = {
      //       'EQP': item.eqpId,
      //       'MODULE': item.moduleId,
      //       'Start Date': item.startDt,
      //       'End Date': item.endDt,
      //       'Event Type': item.eventType,
      //       'Lot Id': item.lotId,
      //       'Substrate Id': item.substId,
      //       'Recipe': item.recipeId,
      //       'slot': item.slot,
      //       'Carrier': item.carrId,
      //       'Batch': item.batchId,
      //       'Oper': item.operId,
      //       'Prod': item.prodId,
      //       'Proc': item.procId,
      //       'Reticle': item.reticleId,
      //       'PPID': item.ppId,
      //       'Device': item.device

      //     }
      //     objArray.push(obj)
      //   })

      //   var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray

      //   var csvContent = 'data:text/csv;charset=utf-8,'
      //   var header = ''

      //   for (var index in array[0]) {
      //     if (index === '_status') continue
      //     header += index + ','
      //   }
      //   header = header.slice(0, -1)
      //   csvContent += header + '\r\n'
      //   var value = ''
      //   var body = ''
      //   for (var i = 0; i < array.length; i++) {
      //     body = ''
      //     for (var bodyIndex in array[i]) {
      //       if (bodyIndex === '_status') continue
      //       value = array[i][bodyIndex]
      //       switch (typeof array[i][bodyIndex]) {
      //         case 'string':
      //           body += '"' + value.replace(/"/g, '""') + '",'
      //           break
      //         case 'boolean':
      //           body += (value === true ? '"' + 'Y' + '"' : '"' + 'N' + '"') + ','
      //           break
      //         default:
      //           body += value + ','
      //           break
      //       }
      //     }
      //     body = body.slice(0, -1)
      //     csvContent += body
      //     if (i < array.length - 1) {
      //       csvContent += '\r\n'
      //     }
      //   }
      //   const data = encodeURI(csvContent)
      //   const link = document.createElement('a')
      //   link.setAttribute('href', data)
      //   link.setAttribute('download', 'EQP-History_' + Dayjs(new Date()).format('YYYYMMDDHHmmss') + '.csv')
      //   link.click()
    }
  },
  data () {
    return {
      fromDate: Dayjs().subtract(1, 'days').toDate(), // From Date (condition)
      fromMinDate: null, // From Date Min value
      fromMaxDate: new Date(), // From Date Max value
      toDate: new Date(), // To Date (condition)
      toMinDate: Dayjs().subtract(2, 'days').toDate(), // To Date Min value
      toMaxDate: new Date(), // To Date Max value
      columns: [], // LOT History grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', minWidth: 70, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.START_DATE'), binding: 'startDt', dataType: 'Date', width: '1*', format: 'yyyy-MM-dd HH:mm:ss', centered: true, minWidth: 130, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.END_DATE'), binding: 'endDt', dataType: 'Date', width: '1*', format: 'yyyy-MM-dd HH:mm:ss', centered: true, minWidth: 130, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.EVENT_TYPE'), binding: 'eventType', centered: true, width: '1*', minWidth: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), binding: 'substId', minWidth: 150, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SLOT'), binding: 'slot', numeric: true, minWidth: 50, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), binding: 'carrId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.BATCH_ID'), binding: 'batchId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.OPER_ID'), binding: 'operId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROD_ID'), binding: 'prodId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROCESS'), binding: 'procId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), binding: 'reticleId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PPID'), binding: 'ppId', minWidth: 100, width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.DEVICE'), binding: 'device', minWidth: 100, width: '1*', readOnly: true }
      // ], // EQP History grid column 배열
      rowData: [], // EQP History grid row data
      originRowData: [], // EQP History grid row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      // searchTreeNode: [],
      collectionViewOptions: {
        groupDescriptions: ['eqpId']
      }, // EQP History grid collectionView Option
      paging: {
        // type: ['none', 'load-more', 'pagination'][2],
        size: 100, // page per size 설정
        currentPage: 0, // 0으로 초기설정
        totalPage: 1, // 1로 초기설정
        totalElements: 1
      }, // EQP History grid pagination option
      noData: false // data 없음 여부
    }
  }
}
